import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { listApiKeys } from '../api/api-keys.js';

export function ApiKeysList(): JSX.Element {
  const { id = '' } = useParams<{ id: string }>();
  const q = useQuery({
    queryKey: ['api-keys', id],
    queryFn: () => listApiKeys(id),
    enabled: Boolean(id),
  });

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold">API Keys</h2>
        <p className="text-xs text-slate-500 mt-1">
          Read-only desde admin. Para crear, revocar o rotar, el tenant-admin debe hacerlo desde su SPA en
          <code className="ml-1 rounded bg-slate-100 px-1 font-mono text-[11px]">.app.dev.zen.zervizdev.com/configuracion</code>.
        </p>
      </div>

      {q.isLoading && <p className="text-sm text-slate-500">Cargando…</p>}
      {q.error && (
        <p className="rounded border border-red-300 bg-red-50 p-2 text-sm text-red-800">
          {(q.error as Error).message}
        </p>
      )}
      {q.data && q.data.length === 0 && (
        <div className="rounded border border-dashed border-slate-300 p-6 text-sm text-slate-500">
          No hay API keys para este tenant.
        </div>
      )}
      {q.data && q.data.length > 0 && (
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase text-slate-500">
            <tr>
              <th className="py-2">Nombre</th>
              <th>Scopes</th>
              <th>Status</th>
              <th>Última uso</th>
              <th>Expira</th>
            </tr>
          </thead>
          <tbody>
            {q.data.map((k) => (
              <tr key={k.id} className="border-t border-slate-200">
                <td className="py-2 font-medium">{k.name}</td>
                <td className="font-mono text-[11px]">{k.scopes.join(', ')}</td>
                <td>
                  <span
                    className={`rounded px-2 py-0.5 text-[10px] ${
                      k.status === 'active' ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-600'
                    }`}
                  >
                    {k.status}
                  </span>
                </td>
                <td className="text-xs text-slate-500">{k.lastUsedAt ?? '—'}</td>
                <td className="text-xs text-slate-500">{k.expiresAt ?? 'nunca'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
